if (!document.body.scrollTo) {
  // @ts-ignore
  Element.prototype.scrollTo = function (x, y) {
    this.scrollLeft = x;
    this.scrollTop = y;
  };
}

if (!window.scrollTo) {
  // @ts-ignore
  window.scrollTo = function (x, y) {
    // @ts-ignore
    window.pageXOffset = x; // @ts-ignore

    window.pageYOffset = y;
  };
}